import { SEOHead } from "@/components/SEOHead";
import { HeaderNavigation } from "@/components/HeaderNavigation";
import { FooterSEO } from "@/components/FooterSEO";
import { Breadcrumbs } from "@/components/Breadcrumbs";
import { ContactForm } from "@/components/ContactForm";
import { MapPin, Mail, MessageSquare } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";

export default function ContactPage() {
  return (
    <div className="min-h-screen bg-background flex flex-col justify-between">
      <SEOHead
        title="İletişim | Corner Gayrimenkul Adana"
        description="Corner Gayrimenkul iletişim bilgileri. Adana Seyhan Gürselpaşa Mahallesi ofis adresi, WhatsApp danışma hattı ve yol tarifi."
        canonicalPath="/iletisim"
      />
      <HeaderNavigation />

      <main className="flex-1 py-8 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto w-full">
        <Breadcrumbs items={[{ label: "İletişim" }]} />

        <div className="mb-12 text-center max-w-3xl mx-auto">
          <span className="px-3 py-1 rounded-full bg-primary/10 text-primary font-bold text-xs uppercase tracking-wider">
            Bize Ulaşın
          </span>
          <h1 className="text-3xl sm:text-5xl font-black text-foreground tracking-tight my-4">
            Corner Gayrimenkul İletişim
          </h1>
          <p className="text-muted-foreground text-lg leading-relaxed">
            Adana Seyhan Gürselpaşa Mahallesi Aliya İzzetbegoviç Bulvarı üzerindeki ofisimizde kahvemizi içmeye bekleriz.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 my-8">
          {/* Info Side */}
          <div className="space-y-6">
            <Card className="p-6 bg-card border border-border">
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 rounded-xl bg-primary/10 text-primary flex items-center justify-center shrink-0 font-bold">
                  <MapPin className="h-6 w-6" />
                </div>
                <div>
                  <h3 className="font-extrabold text-lg text-foreground mb-1">Ofis Adresimiz</h3>
                  <p className="text-muted-foreground text-sm leading-relaxed">
                    Gürselpaşa Mahallesi, Aliya İzzetbegoviç Bulvarı<br />
                    Seyhan / Adana, Türkiye
                  </p>
                </div>
              </div>
            </Card>

            <Card className="p-6 bg-card border border-border">
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 rounded-xl bg-primary/10 text-primary flex items-center justify-center shrink-0 font-bold">
                  <MessageSquare className="h-6 w-6" />
                </div>
                <div className="space-y-2 flex-1">
                  <h3 className="font-extrabold text-lg text-foreground mb-0.5">WhatsApp danışmanlığı</h3>
                  <p className="text-muted-foreground text-sm">Mülk taleplerinizi ve görüşme isteğinizi bize iletin.</p>
                  <div className="flex flex-wrap gap-2 pt-1">
                    <Button asChild size="sm" className="bg-green-600 hover:bg-green-700 font-bold">
                      <a href="https://wa.me/905335487801" target="_blank" rel="noreferrer">
                        <MessageSquare className="h-4 w-4 mr-1.5" /> WhatsApp'tan Yazın
                      </a>
                    </Button>
                  </div>
                </div>
              </div>
            </Card>

            <Card className="p-6 bg-card border border-border">
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 rounded-xl bg-primary/10 text-primary flex items-center justify-center shrink-0 font-bold">
                  <Mail className="h-6 w-6" />
                </div>
                <div>
                  <h3 className="font-extrabold text-lg text-foreground mb-1">E-Posta Adresimiz</h3>
                  <a href="mailto:info@cornergayrimenkul.com.tr" className="text-primary font-bold text-sm hover:underline">
                    info@cornergayrimenkul.com.tr
                  </a>
                </div>
              </div>
            </Card>
          </div>

          {/* Contact Form */}
          <Card className="p-8 bg-card border border-border shadow-xl rounded-3xl">
            <h3 className="text-2xl font-extrabold text-foreground mb-2">Bize Mesaj Gönderin</h3>
            <p className="text-sm text-muted-foreground mb-6">Gayrimenkul talebiniz veya sorularınız için formu doldurabilirsiniz.</p>
            <ContactForm />
          </Card>
        </div>
      </main>

      <FooterSEO />
    </div>
  );
}
